import { Grid, Typography } from "@mui/material";
import { brandingConstants } from "../../PreviewStyles/constants";
import { handleConvertPxToPt } from "../helpers";

const ThankYouPreview = ({
  product,
  previewAgent,
}: {
  product: any;
  previewAgent: boolean;
}) => {
  const { branding } = product;

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Typography
        sx={{
          color: branding?.[brandingConstants.mainTitleColor],
          fontFamily: branding?.[brandingConstants.mainTitleFontFamily],
          fontSize: handleConvertPxToPt(
            branding?.[brandingConstants.mainTitleFontSize],
            previewAgent
          ),
          fontWeight: "900",
          textAlign: "center",
          mb: 0,
        }}
      >
        {product?.thanksStr}
      </Typography>
      <Typography
        sx={{
          mb: 0,
          color: branding?.[brandingConstants.subTitleColor],
          fontFamily: branding?.[brandingConstants.subTitleFontFamily],
          fontSize: handleConvertPxToPt(
            branding?.[brandingConstants.subTitleFontSize],
            previewAgent
          ),
          fontWeight: "500",
          textAlign: "center",
        }}
      >
        {product?.feedbackSettings?.thanksMsg}
      </Typography>
    </Grid>
  );
};

export default ThankYouPreview;
